import { AppLaunchError } from "../../../../utils/constants/appLaunchError";

export const getLaunchErrorMessage = (
  error: Error
): { description?: string; title?: string; altMessage?: string } => {
  let description;
  let title;
  const altMessage = "Exclamation bubble with gear icons";

  switch (error.message) {
    case AppLaunchError.PageNotFound:
      title = "Page not found";
      description = "404";
      break;
    case AppLaunchError.EncounterHasNoAppointmentReference:
      title = "There are no scheduled appointments.";
      break;
    case AppLaunchError.InvalidUrlParams:
    case AppLaunchError.TenantConfigNotFound:
      title = "The tenant setup isn't done quite yet";
      description = "If you need more info, contact your organization's admin.";
      break;
    case AppLaunchError.NoTenantConfigsConfigured:
      title = "The tenant setup isn't done quite yet";
      description = "If you need more info, contact your organization's admin.";
      break;
    case AppLaunchError.UnAuthenticated:
    case AppLaunchError.UnAuthorized:
      title = "Something went wrong";
      description = "Wait a bit, then try to start the app again.";
      break;
    default:
      title = "Please try again.";
      description = "If the error persists, please contact your local IT administrator.";
  }

  return { description, title, altMessage };
};
